import { Observable } from 'rxjs';
import { fromFetch } from 'rxjs/fetch';
import { switchMap, catchError } from 'rxjs/operators';
import { GlobalEnvironment, getParams } from 'Helpers';
import { Categories } from "Models";
import { StatusCodeService } from 'Services';
import { msalTemp } from 'Contexts/AuthProvider';

export class CategoriesService {

    static GetAll(): Observable<Categories[]> {
        const accessToken = msalTemp.getActiveAccount()?.idToken
        const params = { ...getParams, headers: { Authorization: `Bearer ${accessToken}`, "Content-Type": "application/json" } };

        const data$ = fromFetch(`${GlobalEnvironment.GetUrl_API()}api/Categories`, params).pipe(
            switchMap(response => {
                if (response.ok) {
                    return Promise.resolve(response.json());
                } else {
                    return Promise.reject(StatusCodeService.GetMessage(response.status, "CategoriesService.GetAll"));
                }
            }),
            catchError(err => Promise.reject(err))
        );

        return data$;
    }
}